<template>
<v-text-field type="number" v-model="internalValue" :label="label" v-bind="$attrs" v-on="$listeners" @input="v => $emit('input', v)" @blur="$emit('blur', internalValue)" :rules="fieldRules" />
</template>

<script>
export default {
  name: 'MyFloat',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalValue: this.value != null ? this.value : ''
    }
  },
  computed: {
    fieldRules() {
      const isRequired = this.required
      return [
        v => {
          if (!isRequired) return true
          const num = v === '' ? 0 : Number(v)
          return (num > 0) || 'این فیلد الزامی است و باید بزرگتر از صفر باشد'
        }
      ]
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== Number(this.internalValue)) {
        this.internalValue = newVal != null ? newVal : ''
      }
    }
  },
}
</script>
